import { PaymentResponse } from '../../model/response.payment';

export const initialState = {
  loading: false,
  PaymentResponse: new PaymentResponse(),
  error: undefined as string,
};

export type FinanceState = Readonly<typeof initialState>;
